<template lang='pug'>
  div
    v-container(fluid, grid-list-xl)
      v-layout(row, wrap)
        v-flex(xs12)
          v-card
            v-card-text
              u-form(v-model="resultForm" :id='form.key' :json='form.components[0]')
</template>

<script>
import _ from 'lodash'
import {mapState, mapGetters} from 'vuex'

import UForm from '@/components/form/form'
import {db} from '@/store/firebase'

export default {
  name: 'uf-form',

  components: {
    UForm
  },

  computed: {
    ...mapState({
      gestationInteraction: (state) => state.ultraFetal.gestationInteraction
    }),
    ...mapGetters('formCustomization', ['getCustomizedForms', 'getFormByKey']),
    forms () {
      return this.getCustomizedForms
    },
    form () {
      return this.getFormByKey('observations')
    }
  },

  watch: {
    resultForm: {
      handler: function (val) {
        this.save()
      },
      deep: true
    },
    'gestationInteraction.observations' (val) {
      if (!_.isEqual(val, this.resultForm['observations.info.text'])) {
        this.resultForm['observations.info.text'] = val
      }
    }
  },

  data () {
    return {
      msg: 'uf-form',
      tabActive: 0,
      resultForm: {}
    }
  },

  mounted () {
    this.resultForm = {'observations.info.text': this.gestationInteraction.observations}
  },

  methods: {
    save: _.debounce(function () {
      let form = this.resultForm
      db.doc('gestationInteraction/' + this.gestationInteraction.iuid).update({observations: form['observations.info.text'] || null})
    }, 1000)
  }
}
</script>

<style lang='stylus' scoped>
</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/Observations.vue